<template>
    <gofix-card title=" " classHeader="p-0 m-0" class="heig-frame-child" fullContent :class="{'run-loading': loading}">
        <gofix-table
            class="noFullHeight scrollAbsolute"
            :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @new-item="openModal"
            @row-click="openModal"
            @delete-items="deleteItems"
            ref="gofixTable">
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
            <b-form class="pb-20">
                <gofix-form-dropdown
                    label="Avenue of Feedback"
                    :clearable="true"
                    :show-icon-required="true"
                    vLabel="reference_value_text"
                    v-model="modal.data.avenue_of_feedback"
                    :options="modal.options.avenue_of_feedbacks">
                </gofix-form-dropdown>
                <gofix-form-dropdown
                    label="Role"
                    :clearable="true"
                    :show-icon-required="true"
                    vLabel="name"
                    v-model="modal.data.role"
                    :options="modal.options.roles">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="save" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    export default {
        name: 'case-hb-settings-activity',
        components: {
        },
        data () {
            return {
                tableConfig:{
                    name: 'case-settings-activity',
                    controls:{
                        createTooptip:"New Action",
                    },
                    filter: {
                        avenue_of_feedback: {  type: "text", value: "", function: "ilike", with: [] },
                        role_name: {  type: "text", value: "", function: "ilike", with: [] },
                        client_contract_id: {  type: "number", value: this.$route.params.id, function: "=", with: [] },
                    },
                    page: 1,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "asc",
                    itemSelected: [],
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'avenue_of_feedback',
                            label: 'Avenue of Feedback',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:200px",
                            sorting: true,
                        },
                        {
                            key: 'role_name',
                            label: 'Role',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:300px",
                            sorting: true,
                        },
                        {
                            key: 'null',
                            label: '',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: false,
                            with:null,
                            thStyle: "width:nullpx",
                            sorting: false,
                        },
                    ]
                },
                tableItems:[],
                modal:{
                    open: false,
                    loading: false,
                    title:"New PIC Role Mapping",
                    data:{
                        id: null,
                        avenue_of_feedback: null,
                        role: null,
                        client_contract_id: null
                    },
                    options: {
                        avenue_of_feedbacks: [
                            { reference_value_text: 'Hot Button', reference_value_abbr: null },
                            { reference_value_text: 'Estate Spot Check', reference_value_abbr: null }
                        ],
                        roles: []
                    }
                },
                loading: false
            }
        },
        created() {
            this.getRoles();
        },
        methods:{
            //Load data list
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.client_contract_id.value = this.$route.params.id;
                await this.$store.dispatch("CaseSettingsController/getItemPICRoleMapping", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load the data", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },
            //Open modal Edit || Create data
            openModal(item){
                if(item){
                    this.modal.title = "Edit PIC Role Mapping";
                    this.modal.data = {
                        id: item.id,
                        avenue_of_feedback: { reference_value_text: item.avenue_of_feedback, reference_value_abbr: null },
                        role: {
                            id: item.role_id,
                            name: item.role_name
                        },
                        client_contract_id: item.client_contract_id
                    }
                }else{
                    this.modal.title = "New PIC Role Mapping";
                    this.modal.data = {
                        id: null,
                        avenue_of_feedback: null,
                        role: null,
                        client_contract_id: null
                    }
                }
                this.modal.open = true;
            },
            //Update & Create data
            save(){
                if(!this.modal.data.avenue_of_feedback){
                    this.$alertNotification("Avenue of Feedback is a required field.", "danger");
                    return
                }

                if(!this.modal.data.role){
                    this.$alertNotification("Role is a required field.", "danger");
                    return
                }

                let method    = 'createItemPICRoleMapping';
                let msg    = 'added';
                if(this.modal.data.id) {
                    method = 'updateItemPICRoleMapping';
                    msg    = 'updated';
                }

                let params = {
                    id: this.modal.data.id,
                    avenue_of_feedback: this.modal.data.avenue_of_feedback.reference_value_text,
                    role_name: this.modal.data.role.name,
                    role_id: this.modal.data.role.id,
                    client_contract_id: this.ClientContractID.id
                }

                this.$store.dispatch(`CaseSettingsController/${method}`, params)
                    .then(result => {
                        this.$alertNotification(`Successfully ${msg} pic role mapping`);
                        this.modal.open = false;
                        this.$refs['gofixTable'].reloadTableKeepFilter();
                    })
                    .catch(error => {
                        if(error.response && error.response.data.error.message.error) {
                            this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    })
            },
            //Delete data
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("CaseSettingsController/deteleItemPICRoleMapping", ids)
                    .then(response => {
                        resolve("Successfully deleted item");
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            getRoles(){
                this.$store.dispatch("RoleController/getRoleItems",{
                    filter : {
                        group_tags : "FM"
                    }
                }).then(result => {
                    this.modal.options.roles = result.items
                });
            
            }
        }
    }
</script>
